// client\src\components\Clientes\ClienteData.jsx

import { useEffect, useState } from 'react';
import api from '../../api/axios';
import styles from '../../App.module.css';


export function useClienteData(clienteID) {
    const [cliente, setCliente] = useState(null);

    useEffect(() => {
        const fetchCliente = async () => {
            try {
                const response = await api.get(`/cliente/${clienteID}`);
                setCliente(response.data);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do cliente:', error);
            }
        };

        if (clienteID) fetchCliente();
    }, [clienteID]);

    return cliente;
}

function ClienteData({ clienteID }) {
    const [cliente, setCliente] = useState(null);
    const [obsProdutor, setObsProdutor] = useState('');
    const [aguardandoProdutor, setAguardandoProdutor] = useState('');

    useEffect(() => {
        const fetchCliente = async () => {
            try {
                const response = await api.get(`/cliente/${clienteID}`);
                setCliente(response.data);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do cliente:', error);
            }
        };
        fetchCliente();
    }, [clienteID]);

    useEffect(() => {
        const fetchObsProdutor = async () => {
            try {
                const response = await api.get(`/formulariosCliente/${clienteID}`);
                // console.log('Dados dos formulários:', response.data);
                // Busca as observações no array obss
                if (response.data && Array.isArray(response.data.obss) && response.data.obss.length > 0) {
                    setObsProdutor(response.data.obss);
                } else {
                    setObsProdutor(['Nenhuma observação cadastrada.']);
                }

                if (response.data && Array.isArray(response.data.aguardandoo) && response.data.aguardandoo.length > 0) {
                    setAguardandoProdutor(response.data.aguardandoo);
                } else {
                    setAguardandoProdutor(['Nenhuma observação cadastrada.']);
                }

            } catch (error) {
                setObsProdutor(['Erro ao buscar observações.']);
                setAguardandoProdutor(['Erro ao buscar observações.']);
            }

        };
        fetchObsProdutor();
    }, [clienteID]);

    if (!cliente) return <p>Carregando dados do cliente...</p>;

    return (
        <>
            <div className={`${styles.cadastroItems06} ${styles.clienteBox}`}>
                <div style={{
                    padding: "10px",
                    // backgroundColor: "#f4f4",
                    // borderRadius: "10px",
                    textAlign: "left",
                    width: "100%",
                }}>
                    <h3>Dados do Cliente</h3>
                    {cliente.Nome && <p><strong>Nome:</strong> {cliente.Nome}</p>}
                    {cliente.contato && <p><strong>Contato:</strong> {cliente.contato}</p>}
                    {cliente.cpf && <p><strong>CPF:</strong> {cliente.cpf}</p>}
                    {cliente.parceiro && <p><strong>Parceiro:</strong> {cliente.parceiro}</p>}
                    {cliente.fonte && <p><strong>Fonte:</strong> {cliente.fonte}</p>}
                </div>
            </div>

            {Array.isArray(obsProdutor) && !(obsProdutor.length === 1 && obsProdutor[0] === 'Nenhuma observação cadastrada.') && (
                obsProdutor.map((obs, idx) => (
                    <div key={idx} className={`${styles.cadastroItems06} ${styles.clienteBox}`}
                        style={{ backgroundColor: "#008000", color: "white", marginBottom: "10px" }}
                    >
                        <div style={{
                            padding: "10px",
                            textAlign: "left",
                            width: "100%",
                        }}>
                            <h3>Observações para a Produção:</h3>
                            <p>{obs}</p>
                        </div>
                    </div>
                ))
            )}

            {Array.isArray(aguardandoProdutor) && !(aguardandoProdutor.length === 1 && aguardandoProdutor[0] === 'Nenhuma observação cadastrada.') && (
                <div className={`${styles.cadastroItems06} ${styles.clienteBox}`}
                    style={{ backgroundColor: "rgb(255, 182, 40)" }}
                >
                    <div style={{
                        padding: "10px",
                        textAlign: "left",
                        width: "100%",
                    }}>
                        <h3>Aguardando:</h3>
                        <ul>
                            {aguardandoProdutor.map((obs, idx) => (
                                <li key={idx}>{obs}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

        </>
    );
}

export default ClienteData;